import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SocketNotifications } from 'src/app/views/layout/services/socket-notifications.service';


@Injectable()
export class SocketService {
    constructor(private socketNotif: SocketNotifications) { }

    listenToChannel(channel: string): Observable<any> {
        return this.socketNotif.fromEvent(channel);
    }

    // Emit data to a specific channel
    emitToChannel(channel: string, data: any) {
        this.socketNotif.emit(channel, data);
    }

    // Optionally, disconnect from the socket server
    disconnect() {
        this.socketNotif.disconnect();
    }

    // Reconnect to the socket server
    reconnect() {
        this.socketNotif.connect();
    }

    customSocketOn(event: string): Observable<any> {
        return new Observable((observer) => {
            this.socketNotif.on(event, (data: any) => {
                observer.next(data);
            });
            // Clean up the event listener on unsubscribe
            return () => this.socketNotif.off(event);
        });
    }
}
